import { DATA_SOURCE_DISPLAY } from './const';

// initialed state
export const initialState = () => ({
	dataChips: {},
	isAddingChip: false,
	insertedDataDisplayMode: DATA_SOURCE_DISPLAY.SAMPLE.id,
});

const state = initialState();

export default state;
